import { Route, Routes } from 'react-router-dom';
import './App.css';
import HomeScreen from './components/homescreen/HomeScreen';
import PrivacyPolicy from './components/privacypolicy/PrivacyPolicy';
import TermsAndConditions from './components/termsandconditions/TermsAndConditions';
import Cookies from './components/cookies/Cookies';

function App() {
  return (
  <div>
    {/* <HomeScreen/> */}
  <Routes>
  <Route path="/" element={<HomeScreen />} />
  <Route path="/privacypolicy" element={<PrivacyPolicy />} />
  <Route path="/termsandconditions" element={<TermsAndConditions />} />
  <Route path="/cookiepolicy" element={<Cookies />} />

  </Routes>
  </div>
  );
}

export default App;
